/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintain_Clock_TimesInputs */

const en_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintain Clock Times`)
};

const fr_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserver les temps d’horloge`)
};

const de_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeiten beibehalten`)
};

const it_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenere i tempi dell'orologio`)
};

const ru_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддерживайте точность хода часов.`)
};

const es_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantener los tiempos del reloj`)
};

const zh_cn2_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保持时钟时间`)
};

const ja_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計の時間を維持する`)
};

const hi_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घड़ी के समय को बनाए रखें`)
};

const pt_pt2_maintain_clock_times = /** @type {(inputs: Maintain_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter a hora correta`)
};

/**
* | output |
* | --- |
* | "Maintain Clock Times" |
*
* @param {Maintain_Clock_TimesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maintain_clock_times = /** @type {((inputs?: Maintain_Clock_TimesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintain_Clock_TimesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_maintain_clock_times(inputs)
	if (locale === "de") return de_maintain_clock_times(inputs)
	if (locale === "it") return it_maintain_clock_times(inputs)
	if (locale === "ru") return ru_maintain_clock_times(inputs)
	if (locale === "es") return es_maintain_clock_times(inputs)
	if (locale === "zh-CN") return zh_cn2_maintain_clock_times(inputs)
	if (locale === "ja") return ja_maintain_clock_times(inputs)
	if (locale === "hi") return hi_maintain_clock_times(inputs)
	if (locale === "pt-PT") return pt_pt2_maintain_clock_times(inputs)
	return en_maintain_clock_times(inputs)
});